import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchPickupLocations, fetchPickupLocation } from './request';
import {
  createPickupLocation,
  updatePickupLocation,
  deletePickupLocation,
} from '@/api/mutations';
import { PICKUP_LOCATIONS_QUERY_KEY, PICKUP_LOCATION_QUERY_KEY } from './key';
import toast from 'react-hot-toast';

export const usePickupLocations = () => {
  return useQuery({
    queryKey: [PICKUP_LOCATIONS_QUERY_KEY],
    queryFn: fetchPickupLocations,
  });
};

export const usePickupLocation = (id?: number) => {
  return useQuery({
    queryKey: [PICKUP_LOCATION_QUERY_KEY, id],
    queryFn: () => fetchPickupLocation(id!),
    enabled: !!id,
  });
};

export const useCreatePickupLocation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPickupLocation,
    onSuccess: (res) => {
      const msg =
        (res as { response?: string })?.response ?? 'Pickup location created';
      toast.success(msg);
      queryClient.invalidateQueries({ queryKey: [PICKUP_LOCATIONS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useUpdatePickupLocation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePickupLocation,
    onSuccess: (res) => {
      const msg =
        (res as { response?: string })?.response ?? 'Pickup location updated';
      toast.success(msg);
      queryClient.invalidateQueries({ queryKey: [PICKUP_LOCATIONS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useDeletePickupLocation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePickupLocation,
    onSuccess: (res) => {
      const msg =
        (res as { response?: string })?.response ?? 'Pickup location deleted';
      toast.success(msg);
      queryClient.invalidateQueries({ queryKey: [PICKUP_LOCATIONS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};
